export default "__VITE_ASSET__DnRaZUX___"